module.exports = {"320971001":"新城街道","320971100":"步凤镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320971.json
// module id = 1012
// module chunks = 0